import { BaseApiModel } from 'app/models/api/response';
import { CountryCode } from 'app/models/country';

const countryCodeMap = new Map<CountryCode, string>([
    ['ar', 'Argentina'],
    ['be', 'Belgium'],
    ['br', 'Brazil'],
    ['ca', 'Canada'],
    ['co', 'Colombia'],
    ['de', 'Germany'],
    ['dk', 'Denmark'],
    ['es', 'Spain'],
    ['fi', 'Finland'],
    ['fr', 'France'],
    ['gb', 'United Kingdom'],
    ['ie', 'Ireland'],
    ['it', 'Italy'],
    ['my', 'Malaysia'],
    ['mx', 'Mexico'],
    ['nl', 'Netherlands'],
    ['no', 'Norway'],
    ['pl', 'Poland'],
    ['pt', 'Portugal'],
    ['ro', 'Romania'],
]);

export class Country extends BaseApiModel {
    get name() {
        return countryCodeMap.get(this.countryCode);
    }

    countryCode: CountryCode = 'nl';
}
